import moment from 'moment';

import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// region action declarations
// ==========================
// ACTIONS
// ==========================

const GET_NUFARM_BIG_NUMBERS = 'luft/dashboard-home/GET_NUFARM_BIG_NUMBERS';
const GET_NUFARM_BIG_NUMBERS_SUCCESS =
  'luft/dashboard-home/GET_NUFARM_BIG_NUMBERS_SUCCESS';
const GET_NUFARM_BIG_NUMBERS_FAILURE =
  'luft/dashboard-home/GET_NUFARM_BIG_NUMBERS_FAILURE';

// ==========================
// STORE INITIAL STATE
// ==========================
const initialState = {
  bigNumbers: {
    isFetching: false,
    error: '',
    requested: '',
    received: '',
    data: {
      totalLitersAg: 0,
      totalAmount: 0,
      totalPallets: 0,
    },
  },
};
// endregion

// region reducer
// ==========================
// REDUCER
// ==========================
export default function reducer(state = initialState, action) {
  switch (action.type) {
    // ==========================
    // NUFARM BIG NUMBERS
    // ==========================
    case GET_NUFARM_BIG_NUMBERS: {
      return {
        ...state,
        bigNumbers: {
          ...state.bigNumbers,
          requested: action.requested,
          isFetching: true,
          error: '',
        },
      };
    }

    case GET_NUFARM_BIG_NUMBERS_SUCCESS: {
      return {
        ...state,
        bigNumbers: {
          ...state.bigNumbers,
          received: action.received,
          isFetching: false,
          error: '',
          data: action.data,
        },
      };
    }

    case GET_NUFARM_BIG_NUMBERS_FAILURE: {
      return {
        ...state,
        bigNumbers: {
          ...state.bigNumbers,
          isFetching: false,
          error: action.error,
        },
      };
    }

    default:
      return state;
  }
}
// endregion

// region action creators

// ==========================
// PRIVATE ACTION CREATORS
// ==========================
// ==========================
// NUFARM BIG NUMBERS
// ==========================
function _getBigNumbers(requested) {
  return {
    type: GET_NUFARM_BIG_NUMBERS,
    requested,
  };
}

function _getBigNumbersSuccess(data, received) {
  return {
    type: GET_NUFARM_BIG_NUMBERS_SUCCESS,
    data,
    received,
  };
}

function _getBigNumbersFailure(error) {
  return {
    type: GET_NUFARM_BIG_NUMBERS_FAILURE,
    error,
  };
}

// endregion

// region thunks
// ==========================
// PUBLIC THUNKS/ACTION CREATORS
// ==========================
export function getBigNumbers(usePeriodSelecionDates = false) {
  return function (dispatch, getState) {
    const requested = moment().format();
    dispatch(_getBigNumbers(requested));

    (async () => {
      // extract params from state
      const {
        selectedPeriodInitialDate,
        selectedPeriodFinalDate,
        initialPeriod,
        finalPeriod,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
      } = getState().dashboardFilters.filters;

      const params = {
        initialPeriod: usePeriodSelecionDates
          ? selectedPeriodInitialDate
          : initialPeriod,
        finalPeriod: usePeriodSelecionDates
          ? selectedPeriodFinalDate
          : finalPeriod,
        listCompany,
        listCustomers,
        listUf,
        listRegion,
        keyAccount,
      };

      try {
        const response = await luftGet('/Invoice/NuFarm/GetBigNumbers', params);
        const received = moment().format();
        dispatch(_getBigNumbersSuccess(response.data, received));
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getBigNumbersFailure(error),
        );
      }
    })();
  };
}

// endregion
